import { combineReducers } from "redux";
import reducer from "./reducers";

import authReducer from "./reducers/auth";
import journal from "./reducers/journal";

import postReducer from "./reducers/post";
import showcaseReducer from "./reducers/showcase";
import teachingReducer from "./reducers/teaching";

import { journalReducer } from "./reducers/journalReducer";
import { arteFilesReducer } from "./reducers/arteFilesReducer";

import { userReflectionsReducer } from "./reducers/userReflectionsReducer";
import communityGroupsReducer from "./reducers/communityGroupsReducer";
import { showSharePostReducer } from "./reducers/showSharePost";
import teachingCoursesReducer from "./reducers/teachingCourses";
import learningReducer from "./reducers/learning";
import learningMyTaskReducer from "./reducers/learningMyTask";
import publicLinkReducer from "./reducers/publicLink";
import exportReducer from "./reducers/export";
import reflectionFeedbackReducer from "./reducers/reflectionFeedBackReducer";
import videoGalleryReducer from "./reducers/videoGallery"
import commonReducer from "./reducers/commonReducer";
import analyticsReducer from "./reducers/analyticsReducer";
import termsconditionsReducer from "./reducers/termsconditions";
const rootReducer = combineReducers({
  auth: authReducer,
  showcase: showcaseReducer,
  teaching: teachingReducer,

  journal,
  post: postReducer,

  reducer: reducer,

  reflections: userReflectionsReducer,
  journals: journalReducer,
  arteFiles: arteFilesReducer,
  communityGroups: communityGroupsReducer,
  showsharepost: showSharePostReducer,
  teachingCourses: teachingCoursesReducer,
  learning: learningReducer,
  learningMyTask: learningMyTaskReducer,
  publicLink: publicLinkReducer,
  export: exportReducer,
  videoGallery: videoGalleryReducer,
  commonData: commonReducer,
  reflectionFeedbackReducer: reflectionFeedbackReducer,
  analyticsReducer: analyticsReducer,
  termsconditionsReducer: termsconditionsReducer
});

export default rootReducer;
